// @flow
import { createReducer } from "redux-act";

const initialState = [
	{ key: 'coaches-choice', value: 'Coaches Choice' },
	{ key: 'consistency', value: 'Consistency' },
	{ key: 'opposition', value: 'Opposition' },
	{ key: 'venues', value: 'Venues' },
	{ key: 'form', value: 'Form' },
];

export const coachStatsList = createReducer({}, initialState);

export default coachStatsList;


// WEBPACK FOOTER //
// ./src/modules/reducers/coachStats/index.js